import styled from 'styled-components';

export const Container = styled.div`
  margin-left:20vw;
  width:80vw;
  height:100%;
  padding:30px;
  padding-right:20vw;

  @media only screen and (max-width: 600px) {
      padding-top: 4vh;
      margin-left: 0;
      width: 100%;
      padding-right: 0px;
      padding: 30px;
  }

  .bread-crumb{
    display:flex;
    align-items:center; 
    margin-bottom:40px;
    margin-top:10vh;

    @media only screen and (max-width: 600px) {
        flex-direction: column;
        margin-top: 3vh;
    }
    .category{
        color: #0A677C;
        margin-right:3px;
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        letter-spacing: 0.05em;
    }

    .where{
        color: #EB5C1C;
        text-decoration:none;
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        letter-spacing: 0.05em;
    }
  }
  


    .box-control{
        border: 1px solid #ddd;
        width: 125%;
        height: 8vh;
        border-radius: 4px;
        padding-left: 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        
        @media only screen and (max-width: 600px) {
            width: 100%;
            padding-left: 0;
            flex-direction: column;
            height: 300px;
        }

        button{
            background: white;
            border: 1.8px solid #EA5C1E;
            height: 60%;
            border-radius: 4px;
            width: 30%;
            color: #EA5C1E;
            background-color: white;
            margin-right: 15px;
        }

        button:hover{
            filter: none;
            border: none;
            background: linear-gradient(90deg, #EA5C1E 0%, #C13818 100%);
            color: white;
        }

        label{
            background: white;
            border: 1.8px solid #EA5C1E;
            height: 60%;
            border-radius: 4px;
            width: 30%;
            color: #EA5C1E;
            background-color: white;
            margin-right: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 500;
            cursor: pointer;
        }

        label:hover{
            filter: none;
            border: none;
            background: linear-gradient(90deg, #EA5C1E 0%, #C13818 100%);
            color: white;
        }
        
        span {
            font-size: 16px;
            font-weight: 400;
        }

        .buttonSave{
            border: none;
            background: linear-gradient(90deg, #EA5C1E 0%, #C13818 100%);
            float: right;
            color: white;
            
            @media only screen and (max-width: 600px) {
                margin-top: 10px;
                width: 90%;
                margin-right: 0;
            }
        }

        .bt-inverse{
            border: 1px solid #EA5C1E;
            background: white;
            float: right;
            color: #EA5C1E;
        }
        
        .container-control{
            width: 50%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            
            @media only screen and (max-width: 600px) {
                width: 100%;
                flex-direction: column;
            }
        }

        .flex-end{
            justify-content: flex-end;
            
        }

        .input-tolerant{
            background: #eee;
            height: 75%;
            width: 40%;
            margin-right: 20px;
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            align-items: space-evenly;
            justify-content: space-around;
            padding-left: 8px;
            
            @media only screen and (max-width: 600px) {
                width: 90%;
                margin-right: 0;
                margin-top: 10px;
            }

            span{
                font-size: 14px;
            }

            input{
                background: transparent;
                border: none;
                color: #aaa
            }

            select{
                background: transparent;
                border: none;
                color: #888;
            }
        }
    }

    .box-table{
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: none;
        height: max-content;

        .box-header{
            height: 950px;
            width: 75%;
            display: flex;
            flex-direction: column;
            border-radius: 5px;
            border: 2px solid #ddd;
            
            @media only screen and (max-width: 600px) {
                width: 100%;
                height: 2250px;
            }

                .box-container-1{
                    height: 220px;
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    
                    @media only screen and (max-width: 600px) {
                        flex-direction: column;
                        height: 400px;
                        align-items: center;
                    }
                    .content-box-1{
                        margin-left: 30px;
                        height: 100%;
                        width: 230px;
                        padding-top: 35px;
                        
                        @media only screen and (max-width: 600px) {
                            margin-left: 0;
                        }

                        h2{
                            margin-left: 10px;
                        }
                        
                        div{
                            border-radius: 6px;
                            width: 100%;
                            height: 103px;
                            margin-top: 25px;
                            background: #eee;
                            border: 1px solid #ccc;
                            padding-top: 10px;

                            span{
                                margin-left: 10px;
                            }
                            
                            h3{
                                color: #8B9495;
                                width: 100%;
                                font-size: 35px;
                                margin-top: 10px;
                                text-align: center;
                            }
                            .span-share{
                                font-size: 10px;
                            }
                        }
                    }
                    .content-box-1:nth-child(1){
                        margin-left: 1%;
                        @media only screen and (max-width: 600px) {
                            margin-left: 0;
                        }
                    }

                    .content-box-2{
                        height: 103px;
                        width: 100%;
                        display: flex;
                        margin-top: 15px;
                        flex-direction: row;
                        align-items: space-around;
                        justify-content: space-between;
                        padding-left: 1%;
                        padding-right: 1%;
                                                
                        .div-offer{
                            width: 95px;
                            
                            @media only screen and (max-width: 600px) {
                                width: 90%;
                            }
                        }   

                        div{
                            border-radius: 6px;
                            width: 230px;
                            height: 103px;
                            background: #eee;
                            border: 1px solid #ccc;
                            padding-top: 10px;

                            span{
                                margin-left: 10px;
                            }
                            
                            h3{
                                color: #8B9495;
                                width: 100%;
                                font-size: 35px;
                                margin-top: 10px;
                                text-align: center;
                            }
                            
                            .link-h3{
                                text-align: start;
                                padding-left: 15px;
                                font-size: 15px;
                                margin-top: 0px;
                                font-weight: 400;
                            }
                            .u{
                                text-decoration: underline;
                                cursor: pointer;
                            }

                        }
                        .span-min{
                            display: inline-block;
                            text-align: center;
                            margin-left: 0;
                            width: 100%;
                            font-size: 13px;
                        }
                        
                        @media only screen and (max-width: 600px) {
                            padding-left: 0;
                            padding-right: 0;
                            flex-direction: column;
                            height: 600px;
                            align-items: center;
                            
                            div {
                                margin-top: 10px;
                                width: 90%;
                                height: 150px;
                            }
                            .div-Offer {
                                margin-top: 10px;
                                width: 90%;
                                height: 150px;
                            }
                        }
                    }
                }

            h1 {
                height: 100%;
                width: 33.3%;
                padding-left: 10px;
                color: white;
                font-size: 20px;
                display: flex;
                align-items: center;
                font-weight: 500;
                
            }
            
            .h1-border{
                border-right: 1px solid #fff;
            }

            .h1-1{
                min-width: 5%;
            }

            .h1-2{
                min-width: 26%;
            }

            .h1-3{
                min-width: 24%;
            }

            .h1-4{
                min-width: 15%;
            }
            
            .h1-5{
                min-width: 18%;
            }

            .h1-6{
                min-width: 12%;
            }

            .container-divide{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-right: 0px solid red; 

                div{
                    width: 100%;
                    height: 50%;
                    border: none;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    white-space: nowrap;
                    overflow-x: auto;
                }

                .border-top{
                    border-top: 2px solid #ddd;
                }

                .btOptions{
                    cursor: pointer;
                    color: #00AEC8;
                    font-weight:500;
                }

                .divNome{
                    align-items: flex-start;
                    padding-left: 10px;
                }
                
                .divEmail{
                    align-items: flex-start;
                    padding-left: 10px;
                }

                .divTelephone{
                    align-items: flex-start;
                    padding-left: 10px;
                }

                // .btOptions:hover{
                //     background: #00AEC8;
                //     color:white;
                // }

                .divData{
                    font-size: 13px;
                    height: 25%;
                    align-items: flex-start;
                    padding-left: 20px;
                    padding-top: 4px;
                    overflow: hidden;
                    border-top: none;
                    white-space: break-spaces;
                    overflow-y: auto;
                }
                .divDescription{
                    font-size: 15px;
                    height: 50%;
                    align-items: flex-start;
                    padding-left: 20px;
                    overflow: hidden;
                    border-top: none;
                    white-space: break-spaces;
                    color: #0A677C;
                    font-weight: 700;
                    overflow-y: auto;
                }

                .divState{
                    font-size: 14px;
                    height: 25%;
                    align-items: flex-start;
                    padding-left: 20px;
                    overflow: hidden;
                    color: #0A677C;
                    font-weight: 400;
                    border-top: none;
                    white-space: break-spaces;
                    overflow-y: auto;
                }
            }
        }

        .box-body{
            margin-top: 20px;   
            background: white;
            height: max-content;
            display: flex;
            flex-direction: column;

            .table-row{
                display: flex;
                width: 100%;
                height: 120px;
                flex-direction: row;
                border: 2px solid #ddd;
                border-radius: 5px;


                .divID{
                    text-align: center;
                    justify-content: center;
                }
                .border-div{
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-size: 18px;
                    border-right: 2px solid #ddd;
                }

                .table-index{
                    color: #0A677C;
                    font-weight: 600;
                }
                .row-last{
                    border-right: 1px solid #ddd;
                }
            }
        }
    }
`;

export const Item = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
`

export const ImageItem = styled.label`
    min-width: 178px;
    min-height: 128px;
    border-radius: 4px;
    background:url(${props => props.image ? props.image : require('../../assets/adminOfferProperty/imgplaceholder.svg')});
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
    position:relative;
    cursor:pointer;

    input{
        display:none;
    }

    .close{
        display : ${props => props.children[1].props.show ? 'flex' : 'none '};
        position:absolute;
        width: 16px;
        height: 16px;
        background: #FFFFFF;
        right : 10px;
        top : 10px;
        border:none;
        font-size:16px;
        border-radius:8px;
        align-items:center;
        justify-content:center;
    }
`
export const BtnWrapper = styled.div`
    width: 100%;
    height: 128px;
    display:flex;
    justify-content:center;
    align-items:center;
`

export const PlusBtn = styled.button`  
    margin-left:20px;
    background-color:transparent;
    border:none;
`

export const Carousel = styled.div`
    width:100%;
    height:auto;
    overflow-x:auto;
    display:flex;

`

export const DocItem = styled.label`
    min-width: 178px;
    min-height: 128px;
    border-radius: 4px;
    background:url(${props => props.image ? props.image : require('../../assets/adminOfferProperty/docplaceholder.svg')});
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
    position:relative;
    cursor:pointer;

    input{
        display:none;
    }

    .close{
        display : ${props => props.children[1].props.show ? 'flex' : 'none '};
        position:absolute;
        width: 16px;
        height: 16px;
        background: #FFFFFF;
        right : 10px;
        top : 10px;
        border:none;
        font-size:16px;
        border-radius:8px;
        align-items:center;
        justify-content:center;
    }
`